export enum PermissionLevel {
    Unrestricted = 1,
    Restricted = 2,
    Assigned = 3,
}
